import { render, staticRenderFns } from "./AddRecibo3.vue?vue&type=template&id=4c366703"
import script from "./AddRecibo3.vue?vue&type=script&lang=js"
export * from "./AddRecibo3.vue?vue&type=script&lang=js"
import style0 from "./AddRecibo3.vue?vue&type=style&index=0&id=4c366703&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports